module.exports = __webpack_public_path__ + "static/media/delete.12333ffe.svg";